<template>
    <a
        v-cloak
        href="#"
        @click.prevent="favorite"
        class="button simple favoritesButton"
        :class="{ '-active': isFavorite }"
    >
        <img class="link-icon" v-if="isFavorite" :src="imgState.data.added">
        <img class="link-icon" v-else :src="imgState.data.notAdded">
        {{ isFavorite ? 'Remove from favorites' : 'Add to favorites' }}
    </a>
</template>
<script>
import axios from 'axios';

export default {
    data: () => ({
        isFavorite: null,
        imgState: { data: {added: '/img/icons/star-filled.svg', notAdded: '/img/icons/star-outlined.svg' }}
    }),
    mounted() {
        axios.get(`/favorite/${this.id}`).then(({ data }) => this.isFavorite = data)
    },
    props: {
        id: { required: true },
    },
    methods: {
        favorite() {
            if (this.isFavorite) {
                return this.removeFavorite()
            } else {
                return this.createFavorite()
            }
        },
        createFavorite() {
            return axios.post(`/favorite/${this.id}`).then(r => {
                this.isFavorite = true
            })
        },
        removeFavorite() {
            return axios.delete(`/favorite/${this.id}`).then(r => {
                this.isFavorite = false
            })
        },
    },
}
</script>
